<template>
  <f7-popup
    close-on-escape
    :opened="isPopupOpened"
    @popup:closed="ClosePopup()"
  >
    <f7-page
      v-if="itemlist.length > 0"
      class="main-pcLogisticExistenceLocation"
    >
      <template #fixed>
        <TheNavbar
          :nav-title="$t('production.common.goodsLocations')"
          class="at-navbar secondary-navbar"
          :popup-close-btn-enable="true"
        />
      </template>
      <f7-block class="no-padding no-margin">
        <div class="content-logistic-location__total-number">
          <span class="span-little"> {{ $t('production.common.totalSelected') }}</span>
          <span> {{ totalSelected.toFixed(2) }} </span>
        </div>
      </f7-block>
      <f7-block class="content-logistic-location__accordeon no-padding no-margin">
        <UCAcordeon
          :items="itemlist"
          title-option="NombreAgrupacion"
          class="mainAcordeon-merchandise-movements mainAcordeon"
          :show-checkbox="false"
          :show-badge="false"
          :closed="true"
          font-color="var(--his-dark-blue)"
          primary="var(--his-blueberry-mist)"
          :after-title="false"
          :search-with-checkbox="false"
          :uncheck-all-items-on-event-accordion-close="false"
        >
          <template #subOptionSubtitle="{ item }">
            <f7-list>
              <f7-list-item
                checkbox
                class="content-logistic-location-acordeon-list"
                :checked="item.checked"
                @click="ChangeCheck(item)"
              >
                <div class="content-logistic-location-information">
                  <div
                    class="content-location-title"
                  >
                    {{ item.Articulo.Nombre }}
                  </div>
                  <div class="content-location-subtitle">
                    {{ `${$t('common.lot')}: ${item.Lote ? item.Lote.Codigo : ''}` }}
                  </div>
                  <div class="content-location-text">
                    {{ `${$t('common.batch')}: ${item.Partida.Serie} / ${item.Partida.Numero}` }}
                  </div>
                </div>
                <div class="content-logistic-location-after">
                  <div
                    class="content-accordion-items__card"
                    @click="changeSteppQuantity = true; SelectExistences(item)"
                  >
                    <f7-card
                      outline
                      :content="item.Cantidad"
                      :footer="$t('common.stocks')"
                      style="margin: 16px 5px;"
                    />
                    <f7-card
                      outline
                      :content="item.Seleccion === 0 ? '0' : item.Seleccion"
                      footer="Selección"
                      style="margin: 16px 5px;"
                    />
                  </div>
                </div>
              </f7-list-item>
            </f7-list>
          </template>
        </UCAcordeon>
      </f7-block>
    </f7-page>
    <f7-actions
      class="logistic-existence-item-actions-sheet"
      :opened="actionChangesOpened"
      @actions:closed="actionChangesOpened = false"
    >
      <f7-block>
        <div class="content-action-sheet-logistic-existence--items text-align-center">
          <span class="content-action-sheet-logistic-existence--items__title">
            {{ $t('production.common.enterQuantity') }}
          </span>
          <f7-stepper
            :key="accumulatedStockSelected.Id"
            fill
            class="content-action-sheet-logistic-existence--items__stepper"
            :min="0"
            :max="accumulatedStockSelected.CantidadTotal"
            :step="1"
            :manual-input-mode="true"
            :value="accumulatedStockSelected.CantidadFinal"
            @input="valorInputCantidad = $event.target.value"
          />
        </div>
        <div class="content-action-sheet-logistic-existence--items__buttons">
          <f7-button
            class="content-action-sheet-logistic-existence--items__buttons--cancel"
            @click="actionChangesOpened = false"
          >
            {{ $t('common.cancel').toUpperCase() }}
          </f7-button>
          <f7-button
            class="content-action-sheet-logistic-existence--items__buttons--confirm"
            @click="ChangeValueStepper(); actionChangesOpened = false"
          >
            {{ $t('common.confirm').toUpperCase() }}
          </f7-button>
        </div>
      </f7-block>
    </f7-actions>
  </f7-popup>
</template>

<script>
import { defineComponent } from 'vue';
import { Log } from '@/js/common/HIDebuggingSupport';
import { PreloaderGH } from '@/js/common/HINotificationSupport';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import TheNavbar from '@/components/TheNavbar.vue';

export default defineComponent({
  name: 'PCLogisticExistenceLocation',
  components: {
    UCAcordeon,
    TheNavbar,
  },
  props: {
    existencias: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['change-value'],
  data() {
    return {
      /** Indicates whether the popup is currently open. */
      isPopupOpened: false,
      actionChangesOpened: false,
      valorInputCantidad: 0,
      totalSelected: 0,
      dataExistence: [],
      changeSteppQuantity: false,
      selectedItem: [],
      emitData: [],
    };
  },
  computed: {
    itemlist() {
      return this.dataExistence;
    },
    accumulatedStockSelected() {
      return this.selectedItem;
    },
  },
  watch: {
    existencias(val) {
      if (val && val.length > 0) {
        this.FilterData();
      }
    },
  },
  methods: {
    /** Opens the main popup and fetches the current work environment data. */
    async OpenPopup() {
      Log(this, this.OpenPopup.name);
      this.isPopupOpened = true;
    },

    /** Closes the main popup and clears selected data. */
    ClosePopup() {
      Log(this, this.ClosePopup.name);
      this.emitData = this.existencias.filter((f) => f.checked);
      if (this.emitData.length > 0) {
        this.$emit('change-value', this.emitData);
      }
      this.isPopupOpened = false;
    },

    ChangeCheck(item) {
      Log(this, this.ChangeCheck.name);
      if (!this.changeSteppQuantity) {
        item.checked = !item.checked;

        if (!item.checked) {
          item.Seleccion = 0;
        } else {
          item.Seleccion = item.Cantidad;
        }
        // item.Seleccion = item.CantidadTotal;

        if (item.checked) {
          this.totalSelected += item.CantidadTotal;
        } else {
          // this.totalSelected = this.dataExistence.reduce((total, obj) => total + obj.items.reduce((subtotal, i) => subtotal + i.Cantidad, 0), 0);
          this.totalSelected -= item.CantidadTotal;
        }

        if (this.totalSelected <= 0) {
          this.totalSelected = 0;
        }

        // this.$emit('change-value', item);
      }
    },

    ChangeValueStepper() {
      Log(this, this.ChangeValueStepper.name);
      const input = Number.parseFloat(this.valorInputCantidad);
      // const diferencia = this.accumulatedStockSelected.Seleccion - input;

      if (input < this.accumulatedStockSelected.Seleccion) {
        this.selectedItem.Seleccion = Number.parseFloat((this.accumulatedStockSelected.Seleccion - input).toFixed(2));

        this.totalSelected = Number.parseFloat((this.totalSelected - input).toFixed(2));
        if (this.totalSelected <= 0) {
          this.totalSelected = 0;
        }
      } else if (input > this.accumulatedStockSelected.Seleccion) {
        this.selectedItem.Seleccion = Number.parseFloat((this.accumulatedStockSelected.Seleccion + input).toFixed(2));
        this.totalSelected = Number.parseFloat((this.totalSelected + input).toFixed(2));
      }

      if (this.selectedItem.Seleccion !== 0) {
        this.selectedItem.checked = true;
      }
      // this.selectedItem.Seleccion = input;

      // this.existenceList.forEach((e) => {
      //   if (e.Id === this.selectedItem.Id) {
      //     e.Seleccion = input;
      //   }
      // });

      // this.emitData = this.itemlist;
      this.changeSteppQuantity = false;
    },

    SelectExistences(item) {
      Log(this, this.SelectExistences.name);
      this.selectedItem = item;
      this.actionChangesOpened = true;
    },

    FilterData() {
      Log(this, this.FilterData.name);
      PreloaderGH(true, true, this.$t('common.loadingData'), '');

      // this.existenceList = [...this.existencias];
      this.totalSelected = 0;
      const resultado = [];
      const idsUbicacion = [];

      this.existencias.forEach((e) => {
        const { Id: idUbicación } = e.Ubicacion;
        const { Nombre: nombre } = e.Ubicacion;
        const item = e;

        const ubicacionIndex = idsUbicacion.indexOf(idUbicación);
        if (ubicacionIndex === -1) {
          idsUbicacion.push(idUbicación);
          if (item.checked || item.Seleccion > 0) {
            this.totalSelected += item.Seleccion;
            item.checked = true;
          }

          resultado.push({
            UnidadContenedoraId: idUbicación,
            NombreAgrupacion: nombre,
            items: [item],
          });
        } else {
          if (item.checked) {
            this.totalSelected += item.Seleccion;
          }
          resultado[ubicacionIndex].items.push(item);
        }
      });

      this.dataExistence = resultado;
      PreloaderGH(false);
    },
  },
});
</script>

<style lang="scss">
.main-pcLogisticExistenceLocation {
  .accordion-item > .item-link {
    background-color: var(--his-slate-blue);
    --f7-list-chevron-icon-color: #fff;
    --f7-list-item-title-font-weight: 600;

    .item-content .item-inner .item-title {
      color: white;
      font-weight: 500;
    }
  }

  .storybook-action-sorted-accordion .accordion-list .sorted-accordion {
    .accordion-item-content .search-list .item-content {
      padding-left: 0;

      .item-checkbox > .icon-checkbox {
        margin-right: 8px;
      }
    }
  }

  .content-logistic-location__total-number {
    height: 50px;
    display: flex;

    // flex-direction: column;
    justify-content: space-between;
    padding: 10px 15px;
    background: var(--his-blueberry-mist);

    .span-little {
      font-size: 14px;
      color: var(--his-slate-blue);
      display: flex;
      justify-content: flex-end;
    }

    span {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 27px;
      color: var(--his-slate-blue);
      font-weight: 600;
    }
  }

  .content-logistic-location__accordeon {
    height: calc(100vh - var(--f7-page-navbar-offset) - 70px);
    overflow-y: scroll;

    .mainAcordeon-merchandise-movements {
      .accordion-list .accordion-item .item-inner .item-link .item-title {
        font-weight: 500;
      }

      .content-logistic-location-acordeon-list {
        .item-content {
          .item-inner {
            display: flex;
            justify-content: space-between;
            padding-right: 10px;

            .content-logistic-location-after {
              .content-accordion-items__card {
                display: flex;
                --f7-card-bg-color: var(--his-blueberry-mist);
                --f7-card-text-color: var(--his-slate-blue);
                --f7-card-font-size: 20px;

                --f7-card-footer-text-color: var(--his-slate-blue);
                --f7-card-footer-font-size: 13px;

                .card-outline {
                  max-width: 80px;

                  .card-footer {
                    justify-content: center;
                  }
                }

                .card-content {
                  display: flex;
                  justify-content: center;
                  font-weight: 600;
                }
              }
            }

            .content-logistic-location-information {
              .content-location-title {
                font-size: 15px;
                padding-top: 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                font-weight: 600;
              }

              .content-location-subtitle {
                position: relative;
                overflow: hidden;
                white-space: nowrap;
                max-width: 100%;
                text-overflow: ellipsis;
                font-size: var(--f7-list-item-subtitle-font-size);
                font-weight: var(--f7-list-item-subtitle-font-weight);
                color: var(--f7-list-item-subtitle-text-color);
                line-height: var(--f7-list-item-subtitle-line-height);
              }

              .content-location-text {
                position: relative;
                overflow: hidden;
                white-space: nowrap;
                max-width: 100%;
                text-overflow: ellipsis;
                -webkit-line-clamp: var(--f7-list-item-text-max-lines);
                -webkit-box-orient: vertical;
                display: -webkit-box;
                font-size: var(--f7-list-item-text-font-size);
                font-weight: var(--f7-list-item-text-font-weight);
                color: var(--his-orange);
                line-height: var(--f7-list-item-text-line-height);
                max-height: calc(var(--f7-list-item-text-line-height) * var(--f7-list-item-text-max-lines));
              }
            }

            .item-title-row {
              padding: none;
            }
          }
        }
      }

      .span-title {
        font-size: 17px;
        padding-top: 10px;
        font-weight: 600;
      }

      .background-blue {
        background: var(--his-blueberry-mist);
        color: var(--his-slate-blue);
      }

      .background-green {
        background: var(--his-melon-tint);
        color: var(--his-greenlight);
      }

      .background-red {
        background: var(--his-tomate-tint);
        color: var(--his-tomate);
      }
    }
  }
}

.logistic-existence-item-actions-sheet {
  background-color: #fff;

  .content-action-sheet-logistic-existence {
    &--items {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 60px;

      &__title {
        font-size: 18px;
        font-weight: 400;
        padding-bottom: 24px;
        color: var(--his-steel-blue);
      }

      &__buttons {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &--cancel {
          color: var(--his-darkgray);
          border: 1px solid var(--his-darkgray);
          background-color: var(--his-bg);
        }

        &--confirm {
          background-color: var(--his-dark-blue);
          color: #fff;
        }
      }

      &__stepper {
        --f7-stepper-fill-button-text-color: #fff;
        --f7-stepper-height: 36px;
        --f7-stepper-border-radius: 0px;

        .stepper-input-wrap {
          input {
            width: 100px;
            border: none;
          }
        }

        .actions-label::after {
          height: 0 !important;
        }
      }
    }
  }
}
</style>
